import { appConfigDev, appConfigKey, appConfigProd, appPayMethod, appDomain, claimForm, claimMethod, i18n, outputDiv, reCAPTCHAv3, userLanguage } from "commonAssets/js/constants";
import { createElement, formatPhone, toggleFieldAttributeV2, toggleForeignPhone, loadingGif, loadMember, uniformClaimDeadline, ConfirmEmailAddress, clearMessage, localDatetime, modal, validateField, toggleFieldError } from "commonAssets/js/helpers";
import { DigitalDisbursements } from "commonAssets/components/FormBase/DigitalDisbursements";
import { FormFields, FormFieldsLabel } from "commonAssets/components/FormBase/FormFields";
import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { dstMember, dstPaymentIframeTitle, dstProcess } from "commonAssets/components/FormBase/DigitalDisbursements";
import { OptOut } from "commonAssets/components/Forms/OptOut";

export class customSubmitClaim extends SubmitClaim {
    claim_form(params, additionalParams) {
        console.log("[claim_form]")
        // update the claim form deadline
        const deadline_heading = params.form_options.claim_deadline_alert.claim_form;
        const deadline_parser = new DOMParser();
        const deadline_string = deadline_parser.parseFromString(deadline_heading, "text/html");
        const deadline_date_string = deadline_string.querySelector("span");
        // if deadline_date_string is null, then the deadline is not set
        // the if condition was added due to error in i18n translation
        // TODO: remove this if condition after fixing the i18n translation
        if (deadline_date_string !== null) {
            deadline_date_string.textContent = additionalParams;
        }

        // const the form
        const form = createElement("form", {
            class: "needs-validation",
            id: "form",
            method: "post"
        }, [
            createElement("h3", {
                class: "text-center mb-3",
                id: "claimFormDeadline"
            }, [], deadline_string.body.innerHTML),
            createElement("div", {
                class: "alert alert-info text-center fw-bold text-dark",
                id: "confirmation-email-alert",
                role: "alert"
            }, [], params.form_options.claim_form.confirmation_email_notice),
            this.claim_instructions(params),
            this.class_member_benefits(params),
            this.claim_contact_information(params),
            this.claim_fieldset(params),
            //params.claim_transactions ? this.claim_transactions(params) : ``,
            params.claim_upload.documentation.required ? this.claim_documentation(params) : ``,
            appPayMethod ? DigitalDisbursements(params) : ``,
            this.claim_certification(params),
        ]);
        return form;
    }

    class_member_benefits(params) {
        if (params.form_options.claim_form.general_instructions.display === false) {
            return createElement("div", { class: "d-none" });
        }
        return createElement("div", {
            class: "mb-3",
            id: "classMemberBenefitsWrapper",
        }, [
            createElement("div", {
                class: "text-center fw-bold fs-3"
            }, [
                createElement("button", {
                    class: "btn btn-link fs-4 fw-bold",
                    style: "color: #128f76; text-decoration: underline;",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#classMemberBenefits",
                    "aria-expanded": false,
                    "aria-controls": "classMemberBenefits",
                }, [], params.form_options.claim_form.cm_benefits.title)
            ]),
            createElement("div", {
                class: "collapse",
                id: "classMemberBenefits",
            }, [
                createElement("div", {
                    class: "bg-light text-dark border rounded p-3 mb-3",
                }, [], params.form_options.claim_form.cm_benefits.body)
            ]),
        ]);
    }

    claim_fieldset(params) {
        if (params.claim_fields === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_fields.length === 0) {
            return createElement("div", { class: "d-none" });
        }
        const title = params.form_options.claim_form.claim_fields.title;
        const body = params.form_options.claim_form.claim_fields.body;
        const claimFields = createElement("div", {
            class: "bg-light text-dark border rounded p-3 mb-5",
            id: "claim-fields"
        }, [
            createElement("div", { class: "h3 mb-3 formTitle", id: "claimFieldsTitle" }, [], title),
            createElement("div", { class: "mb-3 formBody", id: "claimFieldsBody" }, [], body),
            this.claim_fields(params),
            this.claim_transactions(params)
        ])
        return claimFields;
    }

    claim_transactions(params) {
        if (params.claim_transactions === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_transactions.length === 0) {
            return createElement("div", { class: "d-none" });
        }

        const fieldset = createElement("div", {
            class: "bg-light text-dark border rounded p-3 mb-5",
            id: "transactions"
        }, [
            // createElement("div", {
            //     class: "h3 mb-3 formTitle",
            // }, [], params.form_options.transactions.title),
            // createElement("div", {
            //     class: "mb-3 formBody"
            // }, [], params.form_options.transactions.body),
        ]);

        // For Each Transaction Table
        const claim_transactions = params.claim_transactions;
        let tableID = 0;
        claim_transactions.forEach(table => {
            tableID++; // Begin count at 1.

            // <div class="table-responsive"></div>
            const divResponsiveTable = createElement("div", { class: "table-responsive mb-3", id: "table_responsive_" + tableID });

            // <table class="table transactions"></table>
            const tableTransaction = createElement("table", {
                class: "table table-hover transactions caption-top",
                id: "transactions_" + tableID,
                "data-table-name": table.name,
                "data-table-id": tableID,
            }, [
                createElement("caption", { class: "text-dark bg-transparent" }, [], "<strong>" + table.name + "</strong> &mdash; " + table.description),
            ]);
            divResponsiveTable.appendChild(tableTransaction);

            // <thead class="bg-dark text-light"></thead>
            const tableTHEAD = createElement("thead", { class: "table-dark text-light" });
            tableTransaction.appendChild(tableTHEAD);

            // <tr> ...Table Data Cells... </tr>
            const theadTR = createElement("tr");
            tableTHEAD.appendChild(theadTR);

            // <th scope="col"></th>
            table.columns.forEach(col => {
                const column = createElement("th", { scope: "col" }, [], col.title);
                theadTR.appendChild(column);

                if (Boolean(col.body)) {
                    const helper = createElement("span", { class: "d-block fw-normal", style: "font-size:16px;" }, [], col.body);
                    column.appendChild(helper);
                }
            });

            // <tbody></tbody>
            const tableTBODY = createElement("tbody");
            tableTransaction.appendChild(tableTBODY);

            // Add rows through a function, so we can attach a button.
            let countRow = 1;
            this.claim_transaction_row(table, tableTBODY, tableID, countRow);

            const add_row = createElement("div", {
                class: "text-center",
            }, [
                createElement("a", {
                    class: "btn btn-primary m-1",
                    id: "add_transactions_" + tableID,
                    role: "button",
                    tabindex: "0",
                    "aria-label": i18n.getTranslation('transaction_add_row') + table.name,
                    "tableID": tableID,
                }, [], `<i class="bi bi-plus-circle" tableID="${tableID}"></i> Add Row`),
                createElement("a", { // ada compliance updates - added
                    class: "btn btn-danger m-1 disabled", // default to disabled
                    id: "remove_transactions_" + tableID,
                    role: "button",
                    tabindex: "0",
                    "aria-label": i18n.getTranslation('transaction_delete_row'),
                    "tableID": tableID,
                }, [], `<i class="bi bi-dash-circle" tableID="${tableID}"></i> ${i18n.getTranslation('transaction_delete_row')}`),
            ])

            // ada compliance updates - added
            this.claim_transaction_row_buttons_events(add_row, table, tableTBODY, tableID, countRow);

            // Append the table to the fieldset
            fieldset.appendChild(divResponsiveTable);
            fieldset.appendChild(add_row);
        });

        return fieldset;
    }

    claim_transaction_row(table, tableTBODY, tableID, countRow) {
        const fieldsRow = createElement("tr", {
            class: "transaction-row", // ada compliance updates - added
            id: "transaction_row_" + tableID + "_" + countRow, // ada compliance updates - added
        });
        tableTBODY.appendChild(fieldsRow);
        let fieldID = 0;
        table.fields.forEach(field => {
            fieldID++;
            let td = createElement("td", { class: "transaction " + field.name, });
            let element = createElement("div");
            let validation = field.validation;
            if (field['data-date-min']) {
                validation += ' date-min';
            }
            if (field.type == 'date') {
                validation += ' date-max';
            }
            let formInput = FormFields(field, "", fieldID, element, validation, fieldsRow);
            // set unique name for each field
            field.name = field.name + "__" + countRow;
            FormFieldsLabel(field, fieldID, element);
            // set unique id for each field
            formInput.id = formInput.id + "__" + countRow;
            // set item-id attribute
            formInput.setAttribute("item-id", countRow);
            if (field.label == 'Recall Reimbursement') {
                formInput.addEventListener('change', function() {
                    const reimbursementAmount = document.querySelector(`input[data-label='Reimbursement Amount'][item-id='${countRow}']`);
                    toggleFieldAttributeV2(reimbursementAmount, 'required', this.value == "YES");
                });
            }
            if (formInput.type == 'number') {
                formInput.setAttribute('step', 'any');
                formInput.addEventListener('change', function() {
                    this.value = parseFloat(this.value).toFixed(2);
                });
            }
            if (formInput.type == 'date') {
                if (field['data-date-min']) {
                    formInput.setAttribute('min', field['data-date-min']);
                }
                if (field['data-date-max']) {
                    formInput.setAttribute('max', field['data-date-max']);
                } else {
                    let today = new Date().toISOString().split('T')[0];
                    formInput.setAttribute('data-date-max', today);
                    formInput.setAttribute('max', today);
                }
            }
            formInput.addEventListener('change', function (e) {
                validateField(formInput);
            });
            element.appendChild(formInput);
            td.appendChild(element);
            fieldsRow.appendChild(td);
        });
        return { tableTBODY, fieldsRow };
    }

    claim_transaction_row_buttons_events(add_row, table, tableTBODY, tableID, countRow) {
        // Add row for every click
        add_row.firstChild.addEventListener("click", event => {
            countRow++;
            let table_id = event.target.attributes.tableID.value;
            this.claim_transaction_row(table, tableTBODY, table_id, countRow);
            if (countRow > 0) {
                document.querySelector(`#remove_transactions_${table_id}`).classList.remove('disabled');
            }
            if (countRow > 1) {
                document.querySelector(`#add_transactions_${table_id}`).classList.add('disabled');
            }
        });
        // Remove row for every click
        add_row.lastChild.addEventListener("click", event => {
            countRow--;
            let table_id = event.target.attributes.tableID.value;
            let table = document.querySelector(`#transactions_${table_id}`);
            let table_rows = table.rows.length;
            let table_tbody = table.querySelector('tbody');
            table_tbody.removeChild(table_tbody.lastChild);
            if (table_rows === 3) {
                document.querySelector(`#remove_transactions_${table_id}`).classList.add('disabled');
            }
            document.querySelector(`#add_transactions_${table_id}`).classList.remove('disabled');
        });
    }

    init_claim(form) {
        let _ag_sguid = localStorage.getItem('_ag_SGUID') ? localStorage.getItem('_ag_SGUID') : '';
        this.claim.api.claimsDeadlineGet({ domain: this.claim.data.domain }).then((result) => {

            // Claim Deadline - Default Pacific DateTime
            let datetime;
            if (Boolean(result.data.pacific_datetime)) {
                datetime = result.data.pacific_datetime;
            }
            else {
                datetime = `<pre>Error: datetime</pre>`;
            }

            let claim_deadline;
            if (Boolean(result.data.claim_deadline)) {
                claim_deadline = result.data.claim_deadline;
            }

            // Error Handling
            if (result.data.error) {
                const currentUTCDate = new Date();
                const extendedDeadline = new Date(Date.UTC(2025, 6, 10, 6, 59, 59));
                if (_ag_sguid && !(currentUTCDate > extendedDeadline)) {
                    datetime = 'July 9, 2025 at 11:59:59 P.M.';
                    claim_deadline = extendedDeadline;
                } else {
                    this.setup_result_data_error(result);
                    return;
                }
            }

            const container = createElement("div", {
                class: "display-form",
            });

            /** 
             * Claim Guard
             */
            if (form.form_options.notice_confirmation.display === true) {

                // Guard
                container.appendChild(this.guard(form, datetime));
                outputDiv.appendChild(container);


                const zero_zero_id = document.getElementById('zero_zero_id');
                const confirmation_code = document.getElementById('confirmation_code');
                const skip_guard = document.getElementById("skip-guard");

                // Notice Id and Confirmation Code
                [zero_zero_id, confirmation_code].forEach(function (input) {
                    input.addEventListener('change', validateField);
                });

                // Skip Guard
                if (skip_guard) {
                    skip_guard.addEventListener("click", () => {
                        // Hide guard
                        // document.getElementById('guard').classList.add("d-none");
                        document.getElementById('guard').remove();
                        // New Claim Form
                        container.appendChild(this.claim_form(form, datetime));
                        container.scrollIntoView({ behavior: "smooth" });
                        outputDiv.appendChild(container);

                        // Init claim fields
                        this.init_claim_fields(this.claim, form, claim_deadline);
                    });
                }

                // ada compliance updates - added
                // if input#submit-guard was clicked add .was-verified to form#guard 
                document.getElementById("submit-guard").addEventListener('click', () => {
                    document.getElementById("guard").classList.add("was-validated");
                    // TODO: add required text to labels
                });

                // Validate Guard Fields
                document.getElementById("guard").addEventListener("submit", (e) => {

                    e.preventDefault();

                    var valid = true;
                    var member = {
                        domain: this.claim.data.domain,
                        zero_zero_id: zero_zero_id.value.toUpperCase(),
                        confirmation_code: confirmation_code.value,
                    };

                    clearMessage();

                    // Validate guard fields
                    [zero_zero_id, confirmation_code].forEach(function (input) {
                        valid = validateField(input) && valid;
                    });
                    if (!valid) return;

                    loadingGif(loading, "show");

                    // Retrieve class member data (use POST to pass notice id and confirmation code privately)
                    this.claim.api.classMemberPost({}, member).then((result) => {

                        // Check for error message
                        if (result.data.error) {
                            toggleFieldError(zero_zero_id, true, '');
                            toggleFieldError(confirmation_code, true, '');
                            this.errorHandler.log_exception(new Error('Error loading class member', { cause: result }));
                            this.errorHandler.display_modal(result);
                            return;
                        }

                        if (result.data?.claim_type == 'opt-out') {
                            toggleFieldError(zero_zero_id, true, '');
                            toggleFieldError(confirmation_code, true, '');
                            modal("Error", "Our records indicate that you have previously submitted an opt-out form. If you would like to change your submittal to a claim, please reach out to <a href='mailto:Info@FoodRecallSettlement.com'>Info@FoodRecallSettlement.com</a> to withdraw your previous submittal.");
                            loadingGif(loading, "hide");
                            return;
                        }

                        // Add notice id and confirmation code to claim data
                        this.claim.data.zero_zero_id = member.zero_zero_id;
                        this.claim.data.confirmation_code = member.confirmation_code;

                        // Define the environment for the OTP
                        let environment = this.claim.data.domain.split('.')[0]; // ada compliance - added

                        if (result.data.claim_id) {
                            this.claim.data.claim_id = result.data.claim_id;
                            this.claim.class_member = result.data;
                            if (environment !== 'local') {
                                this.send_otp(form, container, result.data, claim_deadline);
                                return;
                            };
                        }

                        // Populate claim form
                        this.populate_claim_form(form, container, result.data, claim_deadline);

                    }).catch((error) => {
                        this.errorHandler.log_exception(new Error('Error loading class member', { cause: error }));
                        this.errorHandler.display_modal(error);
                    });
                });
            }
            /**
             * No Claim Guard
             */
            else {
                // Edit claim link
                this.edit_claim(form);

                // New Claim Form
                let deadlineSpan = uniformClaimDeadline(claim_deadline);
                container.appendChild(this.claim_form(form, deadlineSpan));
                outputDiv.appendChild(container);

                // Init claim fields
                this.init_claim_fields(this.claim, form, claim_deadline);
            }

            loadingGif(loading, "hide", 250)

        }).catch((error) => {
            this.errorHandler.log_exception(new Error('Error fetching claim deadline', { cause: error }));
            this.errorHandler.display(error);
        });
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        console.log("[populate_claim_form]");
        // set user for error tracking
        this.errorHandler.set_user({ id: class_member.zero_zero_id, email: class_member.email_address });
        // remove guard
        document.getElementById('guard').remove();
        // claim_deadline format December 31, 2024 at 04:00:00 P.M. 
        let deadlineSpan = uniformClaimDeadline(claim_deadline);
        // New Claim Form
        container.appendChild(this.claim_form(form, deadlineSpan));
        container.scrollIntoView({ behavior: "smooth" });
        // output
        outputDiv.appendChild(container);
        // hide loading gif
        loadingGif(loading, "hide", 250);
        // Load member data into form
        loadMember(class_member);
        // custom login member code
        document.getElementById('first_name').disabled = document.getElementById('first_name').value;
        document.getElementById('last_name').disabled = document.getElementById('last_name').value;
        // Payment widget 
        if (appPayMethod && appPayMethod !== "") {
            dstMember();
        }
        if (class_member.claim_id) {
            if (class_member?.claim_files?.length > 0) this.claim.prev_docs = true;
        }
        // Init claim fields
        this.init_claim_fields(this.claim, form, claim_deadline);
    }

    init_claim_fields(claim, form, claim_deadline) {
        if (!document.getElementById('claim-type_1').checked) {
            [
                document.getElementById('covered_products'),
                document.getElementById('purchase_price_total'),
                document.getElementById('received_recall_reimbursement'),
                document.getElementById('recall_reimbursement_amount')
            ].forEach((input) => {
                toggleFieldAttributeV2(input, 'required', false);
                input.parentElement.classList.add('d-none');
            });
            document.getElementById('documentation').classList.add('d-none');
        }

        if (!document.getElementById('claim-type_2').checked) {
            document.getElementById('transactions').classList.add('d-none');
            document.getElementById('transactions').querySelectorAll('input, select').forEach((input) => {
                toggleFieldAttributeV2(input, 'required', false);
            });
        }

        // Claim Inputs
        this.init_claim_inputs();

        // Loop thru available inputs
        this.init_claim_inputs_loop();

        // Validate phone number
        this.setup_phone_number_validation();

        // Country field toggle
        this.setup_country_field_toggle();

        // Confirm email address
        if (document.getElementById('email_address') && document.getElementById('confirm_email_address')) {
            ConfirmEmailAddress('init');
        }

        // Check for file documentation section
        if (document.getElementById('documentation')) {
            // Initialize file uploads
            this.init_claim_files(this.claim);
        }

        dstPaymentIframeTitle(form);

        if (Boolean(document.getElementById("form"))) {

            // ada compliance updates - added
            // TODO: review if this is where this belongs
            // if id="submit-claim" is clicked, add was-validated to form class
            // document.getElementById("submit-claim").addEventListener('click', () => {
            //     document.getElementById("form").classList.add("was-validated");
            // });

            document.getElementById("form").addEventListener('submit', (process) => {
                this.process_claim(process, this.claim, claim_deadline);
            });
        }

        document.getElementById('claim-type_1').addEventListener('click', () => {
            [
                document.getElementById('covered_products'),
                document.getElementById('purchase_price_total'),
                document.getElementById('received_recall_reimbursement'),
                document.getElementById('recall_reimbursement_amount')
            ].forEach((input) => {
                if (input.id != 'recall_reimbursement_amount') {
                    toggleFieldAttributeV2(input, 'required', true);
                }
                input.parentElement.classList.remove('d-none');
            });

            document.getElementById('transactions').classList.add('d-none');
            document.getElementById('transactions').querySelectorAll('input, select').forEach((input) => {
                toggleFieldAttributeV2(input, 'required', false);
                input.value = '';
            });

            document.getElementById('documentation').classList.remove('d-none');
        });

        document.getElementById('claim-type_2').addEventListener('click',() => {
            document.getElementById('transactions').classList.remove('d-none');
            document.getElementById('transactions').querySelectorAll('input:not([id^="reimbursement_amount"]), select').forEach((input) => {
                toggleFieldAttributeV2(input, 'required', true);
            });

            [
                document.getElementById('covered_products'),
                document.getElementById('purchase_price_total'),
                document.getElementById('received_recall_reimbursement'),
                document.getElementById('recall_reimbursement_amount')
            ].forEach((input) => {
                toggleFieldAttributeV2(input, 'required', false);
                input.parentElement.classList.add('d-none');
                input.value = '';
            });

            document.getElementById('documentation').classList.add('d-none');
        });

        document.getElementById('received_recall_reimbursement').addEventListener('change', function() {
            toggleFieldAttributeV2(document.getElementById('recall_reimbursement_amount'), 'required', this.value == 'YES');
        });

        document.getElementById('purchase_price_total').addEventListener('change', function() {
            this.value = parseFloat(this.value).toFixed(2);
        });
        document.getElementById('recall_reimbursement_amount').addEventListener('change', function() {
            this.value = parseFloat(this.value).toFixed(2);
        });

        loadingGif(loading, "hide", 1000);
    }

    init_claim_inputs() {
        let claimInputsContact = '#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST';
        let claimInputsFields = '#claim-fields input:not([item-id]), #claim-fields textarea, #claim-fields select:not([item-id])';
        let claimInputsFieldsPayment = '#payment_method, #payment_token, #payment_email, #payment_phone';
        let claimInputsTransactions = '#transactions input, #transactions textarea, #transactions select';

        this.claim.inputs.contact = Array.from(document.querySelectorAll(claimInputsContact));
        this.claim.inputs.fields = Array.from(document.querySelectorAll(claimInputsFields + ', ' + claimInputsFieldsPayment));
        this.claim.inputs.transactions = Array.from(document.querySelectorAll(claimInputsTransactions));
    }

    process_claim(e, claim, deadline) {
        console.log("[process_claim]")

        /**
         * Prevent the default form submission.
         * 
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         * 
         * Since: 2023.09.25
         * 
         * @returns {void}
         */
        document.getElementById('submit-claim').disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.init_claim_inputs();

        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById('documentation')) {
            this.process_claim_files(this.claim);
        }

        if (document.getElementById('email_address') && document.getElementById('confirm_email_address')) {
            ConfirmEmailAddress('process', this.claim);
        }

        // // if appPayMethod is defined and not empty, we run dstProcess from FormBase/DigitalDisbursements.js
        // if (appPayMethod && appPayMethod !== "" && this.customDstProcess === null) {
        //     claim = dstProcess(this.claim);
        // }
        // else if (appPayMethod && appPayMethod !== "" && this.customDstProcess !== null) {
        //     claim = this.customDstProcess(this.claim);
        // }

        /**
         * Define the environment for the s3 uploader.
         */
        let s3env = this.config.url;

        let custom_errors = '';

        let docs_uploaded = this.claim.prev_docs || claim.uploads.length > 0;
        let docs_required = document.getElementById('claim-type_1').checked;
        if (docs_required && !docs_uploaded) {
            custom_errors += `<br>Please upload supporting documentation.`
            claim.flags.valid = false;
        }

        if (!document.getElementById('payment_method') || !document.getElementById('payment_token') || !document.getElementById('payment_method').value || !document.getElementById('payment_token').value) {
            custom_errors += `<br>${i18n.getTranslation('payment_select_error')}`;
            claim.flags.valid = false;
        }

        if (document.getElementById('email_address').value && document.getElementById('payment_email').value && document.getElementById('email_address').value.toLowerCase() != document.getElementById('payment_email').value.toLowerCase()) {
            custom_errors += `<br>${i18n.getTranslation('claim_processing_email_error')}`;
            claim.flags.valid = false;
        }

        if (document.getElementById('phone_number_1').value && document.getElementById('payment_phone').value && document.getElementById('phone_number_1').value.replace(/\D/g, '') != document.getElementById('payment_phone').value.replace(/\D/g, '')) {
            custom_errors += `<br>${i18n.getTranslation('claim_processing_phone_error')}`;
            claim.flags.valid = false;
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise.execute(reCAPTCHAv3, { action: 'submit' }).then((token) => {
                claim.data.token = token;
                this.post_claim(claim, s3env);
            });
        } else {
            document.getElementById('submit-claim').disabled = false;
            var error = document.querySelector('label.error, #file-notice.error, #no-files.error');
            let timeout = 0;
            if (error && typeof error.scrollIntoView == 'function') {
                error.scrollIntoView({ behavior: "smooth" });
                timeout = 500;
            }
            setTimeout(() => {
                modal(i18n.getTranslation('error'), i18n.getTranslation('claim_form_errors') + custom_errors);
            }, timeout);
        }
    }

    claim_certification(params) {
        const today = new Date().toLocaleString();
        const _ag_uuid = document.cookie.split("; ").find((row) => row.startsWith("_ag_UUID="))?.split("=")[1];
        const _ag_referrer = document.cookie.split("; ").find((row) => row.startsWith("_ag_URL="))?.split("=")[1];
        const _ag_sguid = localStorage.getItem('_ag_SGUID') ? localStorage.getItem('_ag_SGUID') : '';
        const _ag_TEST = localStorage.getItem('_ag_TEST') ? localStorage.getItem('_ag_TEST') : '';

        const fieldset = createElement("div", {
            class: "bg-light text-dark border rounded p-3 mb-5",
            id: "certification",
        }, [
            createElement("div", { class: "h3 mb-3 formTitle", }, [], params.certification.attestation.title),
            createElement("p", { class: "mb-3", }, [], params.certification.attestation.body),
            createElement("div", { class: "row", }, [
                createElement("div", { class: "col-md-5" }, [
                    createElement("input", {
                        type: "text",
                        name: "signature",
                        class: "form-control",
                        id: "signature",
                        "data-validate": "required",
                        "data-contact-label": "Signature",
                        placeholder: i18n.getTranslation('signature_placholder'),
                        required: "", // ada compliance updates - added
                    }),
                    createElement("label", { for: "signature", }, [], `${i18n.getTranslation('signature')}* <span class="error"></span>`),
                ]),
                createElement("div", { class: "col-md-5" }, [
                    createElement("input", { type: "text", name: "date", class: "form-control", id: "date", "data-validate": "required", "data-contact-label": "Date", disabled: "disabled", value: today, }),
                    createElement("label", { for: "date", }, [], `${i18n.getTranslation('date')} <span class="error"></span>`),
                ]),
                createElement("div", {
                    class: "col-md-2",
                }, [
                    createElement("div", {
                        class: "d-grid"
                    }, [
                        createElement("input", { type: "hidden", id: "site_id", value: reCAPTCHAv3, }),
                        createElement("input", { type: "hidden", name: "ag_UUID", id: "ag_UUID", value: _ag_uuid, }),
                        createElement("input", { type: "hidden", name: "referer_url", id: "referer_url", value: _ag_referrer, }),
                        createElement("input", { type: "hidden", name: "user_language", id: "user_language", value: userLanguage, }),
                        createElement("input", { type: "hidden", name: "ag_SGUID", id: "ag_SGUID", value: _ag_sguid, }),
                        Boolean(_ag_TEST) ? createElement("input", { type: "hidden", name: "ag_TEST", id: "ag_TEST", value: _ag_TEST, }) : ``,
                        createElement("input", {
                            type: "submit",
                            class: "btn btn-primary",
                            id: "submit-claim",
                            value: i18n.getTranslation('submit_btn'),
                        })
                    ]),
                ]),
            ]),
            createElement("div", { class: "text-center mt-3" }, [], `<strong>If you have any questions, please contact the Claim Administrator by email at <a href='mailto:Info@FoodRecallSettlement.com'>Info@FoodRecallSettlement.com</a>.</strong>`)
        ]);
        return fieldset;
    }

    destroy_claim(claim) {
        loadingGif(loading, "hide", 500); // left here

        if (claim.flags.success) {

            claim.data.confirmation = this.claim_data_confirmation(claim.data);
            document.querySelector('div.display-form').classList.add('d-none');

            outputDiv.appendChild(this.claim_confirmation(claim.data));
            outputDiv.scrollIntoView({ behavior: "smooth" });

            setTimeout(() => {
                modal(i18n.getTranslation('confirmation_screen_additional')['title'], i18n.getTranslation('confirmation_screen_additional')['body']);
            }, 250);

            // jsb tags
            fbq('track', 'Lead');

            gtag("event", "generate_lead", {
                currency: "USD",
                value: 1
            });

            outputDiv.appendChild(createElement("div", { class: "d-none" }, [], `<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=l6qff4o&ct=0:amtbvdj&fmt=3"/>`));

            twq('event', 'tw-o7f0u-pyifv', {
                conversion_id: null // use this to pass a unique ID for the conversion event for deduplication (e.g. order id '1a2b3c')
            });

            // add this before event code to all pages where PII data postback is expected and appropriate 
            ttq.identify({
                    "email": "<hashed_email_address>", // string. The email of the customer if available. It must be hashed with SHA-256 on the client side.
                    "phone_number": "<hashed_phone_number>", // string. The phone number of the customer if available. It must be hashed with SHA-256 on the client side.
                    "external_id": "<hashed_external_id>" // string. Any unique identifier, such as loyalty membership IDs, user IDs, and external cookie IDs.It must be hashed with SHA-256 on the client side.
            });
            ttq.track('SubmitApplication', {
                    "contents": [
                            {
                                    "content_id": "<content_identifier>", // string. ID of the product. Example: "1077218".
                                    "content_type": "<content_type>", // string. Either product or product_group.
                                    "content_name": "<content_name>" // string. The name of the page or product. Example: "shirt".
                            }
                    ],
                    "value": "<content_value>", // number. Value of the order or items sold. Example: 100.
                    "currency": "<content_currency>" // string. The 4217 currency code. Example: "USD".
            });

            ttq.track('CompleteRegistration', {
                    "contents": [
                            {
                                    "content_id": "<content_identifier>", // string. ID of the product. Example: "1077218".
                                    "content_type": "<content_type>", // string. Either product or product_group.
                                    "content_name": "<content_name>" // string. The name of the page or product. Example: "shirt".
                            }
                    ],
                    "value": "<content_value>", // number. Value of the order or items sold. Example: 100.
                    "currency": "<content_currency>" // string. The 4217 currency code. Example: "USD".
            });

        } else {
            modal(i18n.getTranslation('error'), i18n.getTranslation('claim_submit_error'));
        }

        // Loop thru each input and disable to prevent changes and resubmissions
        for (var type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    field.disabled = true;
                });
            }
        }

        [].forEach.call(document.querySelectorAll('input[type="radio"]'), function (radio) {
            radio.setAttribute('disabled', 'disabled');
        });

        document.getElementById('submit-claim').setAttribute('disabled', 'disabled');
    }
}

export class customOptOut extends OptOut {  
    exclusion_form(params) {
        // create the exclusion form
        const claimFormElems = [
            createElement("h3", {
                class: "text-center text-decoration-underline mb-3",
            }, [], params.form_options.exclusion_form.title),
            createElement("div", {
                class: "alert alert-info text-dark text-center fw-semibold mb-3",
                id: "exclusion_form_top_notice",
            }, [], params.form_options.exclusion_form.top_notice),
            createElement("div", {
                class: "text-center mb-3",
            }, [], params.form_options.exclusion_form.body),
            this.claim_contact_information(params),
        ];
        // if the claim fields were enabled push to form
        if (this.enableClaimFields) {
            claimFormElems.push(this.claim_fieldset(params));
        }
        // if the transational table is enabled, push to form
        if (this.enableClaimTransactions) {
            claimFormElems.push(this.claim_transactions(params));
        }
        // push the attestation to the form
        claimFormElems.push(this.claim_certification(params.form_options.exclusion_form));
        // build the form and add elements
        const form = createElement("form", {
            class: "needs-validation",
            id: "form",
            method: "post"
        }, claimFormElems);
        // return the html form
        return form;
    }

    claim_deadline(params, additionalParams) {

        // id="deadline_datetime" handling
        const alert = `<p class="mb-0">${params.form_options.exclusion_deadline_alert.body}</p>`;
        const parser = new DOMParser();
        const string = parser.parseFromString(alert, "text/html");

        const date_string = string.querySelector("span");
        date_string.textContent = additionalParams;

        const div = createElement("div", {
            class: "alert alert-warning my-3 text-center",
            id: "claim_form_alert"
        }, [], string.body.innerHTML);

        return div;
    }
    
    claim_contact_information(params) {
        let contactInfoBodyDisplayBool = (Boolean(params.form_options.exclusion_form.contact_information.body)) ? true : false;
        const div = createElement("div", {
            class: "bg-light text-dark border rounded p-3 mb-5",
            id: "contact-information",
        }, [
            createElement("div", { class: "h3 mb-3 formTitle", id: "contactInfoTitle" }, [], params.form_options.exclusion_form.contact_information.title),
            contactInfoBodyDisplayBool ? createElement("div", { class: "mb-3 formBody", id: "contactInfoBody" }, [], params.form_options.exclusion_form.contact_information.body) : ``,
            this.claim_contact_fields(params),
        ]);
        return div;
    }

    // init_exclusion_guard(form, container, datetime, exclusion_deadline) {

    //     // Guard
    //     container.appendChild(this.guard(form, datetime));
    //     outputDiv.appendChild(container);

    //     const zero_zero_id = document.getElementById('zero_zero_id');
    //     const confirmation_code = document.getElementById('confirmation_code');
    //     const skip_guard = document.getElementById("skip-guard");

    //     // Notice Id and Confirmation Code
    //     [zero_zero_id, confirmation_code].forEach(function (input) {
    //         input.addEventListener('change', validateField);
    //     });

    //     // Skip Guard
    //     if (skip_guard) {
    //         skip_guard.addEventListener("click", () => {
    //             // Hide guard
    //             document.getElementById('guard').classList.add("d-none");
    //             // New Claim Form
    //             container.appendChild(this.exclusion_form(form));
    //             container.scrollIntoView({ behavior: "smooth" });
    //             outputDiv.appendChild(container);

    //             // Initiate opt out fields
    //             this.init_exclusion_fields();

    //             // Submit form
    //             document.getElementById("form").addEventListener('submit', (process) => {
    //                 this.process_exclusion(process, this.exclusion, exclusion_deadline);
    //             });
    //         });
    //     }

    //     // Validate Guard Fields
    //     document.getElementById("guard").addEventListener("submit", (e) => {
    //         e.preventDefault();

    //         var valid = true;
    //         var member = {
    //             domain: this.claim.data.domain,
    //             zero_zero_id: zero_zero_id.value.toUpperCase(),
    //             confirmation_code: confirmation_code.value,
    //         };

    //         clearMessage();

    //         // Validate guard fields
    //         [zero_zero_id, confirmation_code].forEach(function (input) {
    //             valid = validateField(input) && valid;
    //         });
    //         if (!valid) return;

    //         loadingGif(loading, "show");

    //         // Retrieve class member data (use POST to pass notice id and confirmation code privately)
    //         this.claim.api.classMemberPost({}, member).then((result) => {

    //             // Check for error message
    //             if (result.data.error) {
    //                 toggleFieldError(zero_zero_id, true, '');
    //                 toggleFieldError(confirmation_code, true, '');
    //                 this.errorHandler.log_exception(new Error('Error fetching class member', { cause: result }));
    //                 this.errorHandler.display_modal(result);
    //                 return;
    //             }

    //             if (result.data?.claim_type == 'login') {
    //                 toggleFieldError(zero_zero_id, true, '');
    //                 toggleFieldError(confirmation_code, true, '');
    //                 modal("Error", "Our records indicate that you have previously submitted a claim form. If you would like to change your submittal to an opt-out, please reach out to <a href='mailto:Info@FoodRecallSettlement.com'>Info@FoodRecallSettlement.com</a> to withdraw your previous submittal.");
    //                 loadingGif(loading, "hide");
    //                 return;
    //             }

    //             // Add notice id and confirmation code to claim data
    //             this.exclusion.data.zero_zero_id = member.zero_zero_id;
    //             this.exclusion.data.confirmation_code = member.confirmation_code;

    //             // Check for existing claim number and add to claim data
    //             if (result.data.claim_id) {
    //                 this.exclusion.data.claim_id = result.data.claim_id;
    //             }

    //             // Hide guard
    //             document.getElementById('guard').classList.add("d-none");

    //             // New Claim Form
    //             container.appendChild(this.exclusion_form(form));
    //             container.scrollIntoView({ behavior: "smooth" });
    //             outputDiv.appendChild(container);

    //             loadingGif(loading, "hide", 250);

    //             // Load member data into form
    //             loadMember(result.data);

    //             // Init claim fields
    //             this.init_exclusion_fields(this.exclusion, form);

    //             // Submit Exclusion
    //             document.getElementById("form").addEventListener('submit', (process) => {
    //                 this.process_exclusion(process, this.exclusion, exclusion_deadline);
    //             });

    //         }).catch((error) => {
    //             this.errorHandler.log_exception(new Error('Error fetching class member', { cause: error }));
    //             this.errorHandler.display_modal(error);
    //         });
    //     });
    // }
}